<template>
  <div class="message-items">
    <div v-for="(list, key) in item.wt" :key="key" class="tag-list">
      <template v-if="list.tags.length">
        <div class="word">
          <span>{{ $t('trainerTag.hasBeenTag', [list.word]) }}</span>
          <div class="edited" v-if="list.edited">
            {{ ` ${$t('trainerTag.edited')} ` + getFormattedTS(list.updated_at) }}
          </div>
        </div>
        <div class="tag">
          <p v-for="(tag, idx) in list.tags" :key="idx">{{ tag.name }}</p>
          <span v-if="!hideEdit" @click="setEditTag(list)">Edit</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    item: {
      type: Object
    },
    tempMessage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapState(['accType']),
    ...mapGetters(['isTrainer', 'isStudent', 'isLessonEnded']),

    hideEdit() {
      return this.isStudent || this.isLessonEnded || this.tempMessage;
    }
  },
  methods: {
    ...mapMutations('trainerTag', ['setEditTag']),

    getFormattedTS(ts) {
      const offset = this.isTrainer ? '+0700' : '';
      return this.$moment(ts).utcOffset(offset).format('hh:mm A')
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/trainer_tag.css"></style>
